// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"modalContent--XZzvw","modalImage":"modalImage--6oPzW","modalText":"modalText--mMm5w","modalTitle":"modalTitle--sgP6-","closePopup":"closePopup--UDy3c"};